export const getErrorReason = (graphQLErrors): string => {
  const [graphQLError] = graphQLErrors || [];

  // biome-ignore lint/suspicious/noConsole: logging info in console
  console.log('graphQLError', graphQLError);
  const { extensions: { exception: { errors = [] } = {} } = {} } = graphQLError || {};

  const [firstError] = errors || [];
  const { reason } = firstError || {};

  return reason || '';
};

export const tableNotFoundError = 'TABLE_NOT_FOUND';

export const suppressableOperations = ['GetAudienceCategoriesReach', 'GetSfAccountNames'];
